import { IconLocation16, useDeviceType } from '@cian/ui-kit';
import { clsx as cx } from 'clsx';
import * as React from 'react';

import * as styles from './LocationButton.css';

interface ILocationButtonProps {
  onClick(): void;
}

export const LocationButton: React.FC<ILocationButtonProps> = props => {
  const deviceType = useDeviceType();

  return (
    <button
      type="button"
      className={cx(styles['location-button'], styles[`location-button--${deviceType}`])}
      {...props}
    >
      <IconLocation16 color="primary_100" />
    </button>
  );
};
